import {MessagePrimitive} from '@assistant-ui/react';
import {DotProgress} from '@wandb/components';
import React, {type FC} from 'react';

import {useNightModeRevertFilter} from './useNightModeRevertFilter';
import {MarkdownText} from './WBAgentMarkdown';
import {WBAgentToolCall} from './WBAgentToolCall';
import {WBAgentToolGroup} from './WBAgentToolGroup';

export const AssistantMessage: FC = () => {
  return (
    <MessagePrimitive.Root
      className="mx-auto w-full max-w-(--thread-max-width) pt-16"
      data-role="assistant">
      <MessagePrimitive.If hasContent={false}>
        <div className="flex flex-col items-start self-stretch text-[#C5C7CC]">
          <DotProgress aria-label="agent thinking" />
        </div>
      </MessagePrimitive.If>
      <div className="flex flex-col gap-8 break-words px-2 text-moon-650 text-[15px] leading-[21px]">
        <MessagePrimitive.Parts
          components={{
            Text: MarkdownText,
            ToolGroup: WBAgentToolGroup,
            tools: {
              Fallback: WBAgentToolCall,
            },
          }}
        />
      </div>
    </MessagePrimitive.Root>
  );
};

export const UserMessage: FC = () => {
  const nightModeRevertFilter = useNightModeRevertFilter();

  return (
    <MessagePrimitive.Root
      className="flex flex-col items-end gap-10 pl-24 pt-16"
      data-role="user">
      <div className="relative break-words rounded-2xl px-16 py-8 text-moon-800 text-[15px] font-normal">
        <div
          className="absolute inset-0 rounded-2xl bg-moon-100 dark:bg-moon-750"
          style={{filter: nightModeRevertFilter}}
        />
        <div className="relative">
          <MessagePrimitive.Parts />
        </div>
      </div>
    </MessagePrimitive.Root>
  );
};
